// extracted by mini-css-extract-plugin
export default {"form":"styles_form__OrCKa","inputField":"styles_inputField__hVtaT","labelClassName":"styles_labelClassName__ojBEG"};